import _ from 'lodash'
import React, { PureComponent } from 'react'
import Text from 'react-svg-text'
import { getPhenomenonUrl } from '../helpers'
import classNames from 'classnames'
import { PhenomenonType } from '@futures-platform/ui'
import WaterMarkFP from './WaterMarkFP.svg'
import WaterMarkFPPng from './watermark-fp.png'
import {
    getIndicatorState,
    getIndicatorPositions,
    INDICATOR_RADIUS,
    INDICATOR_GAP,
    TEXT_WIDTH_REDUCTION
} from '../helpers/assessmentStatus'
import { getGroupInitials, getInitialsColor, getInitialsFontScale } from '../helpers/groupInitials'
import {
    VotingIndicator,
    RatingIndicator,
    CommentingIndicator
} from './icons/AssessmentIndicators'

export default class Phenomenon extends PureComponent {
    handleDrag = e => {
        // turning off prevent default because it didn't allow phenomena to open on ipad
        // e.preventDefault()
        e.stopPropagation()
        const { onPhenomenaDrag, phenomenon } = this.props
        onPhenomenaDrag(e, phenomenon)
    }

    componentDidMount() {
        const { onPhenomenaDrag } = this.props

        if (onPhenomenaDrag) {
            this.phenomena.addEventListener('mousedown', this.handleDrag)
            this.phenomena.addEventListener('touchstart', this.handleDrag)
            this.phenomena.addEventListener('ontouchstart', this.handleDrag)
        }
    }

    componentWillUnmount() {
        const onPhenomenaDrag = this.props

        if (onPhenomenaDrag) {
            this.phenomena.removeEventListener('mousedown', this.handleDrag)
            this.phenomena.addEventListener('touchstart', this.handleDrag)
            this.phenomena.addEventListener('ontouchstart', this.handleDrag)
        }
    }

    phenomenonRef = ref => {
        this.phenomena = ref
    }

    getPhenomenonType = () => {
        const { phenomenaTypesById, phenomenon: { content: { type: id } } } = this.props

        const defaultValue =  _.find(phenomenaTypesById, type => type.alias === 'undefined')

        return phenomenaTypesById[id] || defaultValue
    }

    getClassNameState = () => {
        const { alias } = this.getPhenomenonType()

        return alias
    }

    includesTag = (tags, filter) => {
        let includes = false

        _.map(tags, tag => {
            if (_.includes(filter, tag)) {
                includes = true
            }
        })

        return includes
    }

    getFilterClassName = () => {
        const { id } = this.getPhenomenonType()
        const { filter, tagFilter, phenomenon: { tags } } = this.props

        if (
            filter
            && filter.length
            && !(_.find(filter, setFilter => setFilter.id === id))
        ) {
            return 'phenomenon-disabled'
        }

        if (
            tagFilter
            && tagFilter.length
            && !this.includesTag(tags, tagFilter)
        ) {
            return 'phenomenon-disabled'
        }

        return null
    }

    getClassNameDrag = (dragged, deleting) => {
        if (dragged && deleting) {
            return 'deleting'
        }

        if (dragged) {
            return 'dragged'
        }

        return ''
    }

    triggeringOpeningContentCardModalHandler = (href, thisElm) => {
        const evt = new CustomEvent("ContentCardOpened", {detail: {href: href, thisElm: thisElm}});
        window.parent.dispatchEvent(evt)
        console.log('dispatched ContentCardOpened event for opening specific card modal for radar sketch for AIF', evt, thisElm)
    }

    render() {
        const {
            deleting,
            labelWidth,
            phenomenaSize,
            cx,
            cy,
            fontSize,
            dragged,
            hidden,
            radarId,
            phenomenon,
            votingOn,
            ratingsOn,
            commentsOn,
            showAssessmentStatus,
            assessmentData,
            radarGroupId,
            isAIFCreatePreviewRadar,
            publicPhenomenaGroups,
        } = this.props

        const { content: { title, short_title }, group, halo } = phenomenon

        // todo change to use project URL
        // eslint-disable-next-line
        // const watermarkLink = 'https://go2.futuresplatform.com/sites/all/themes/AltFutures_theme/images/watermark-fp.png?v=2'
        const watermarkLink = WaterMarkFPPng || 'https://go2.futuresplatform.com/sites/default/files/watermark-fp.png'
        // const watermarkLink = 'https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.bananamoon.com%2Fen%2Fwomen-floral-swimsuit&psig=AOvVaw1cAc5J7Yq6PIr0AQLTFBBH&ust=1668439456742000&source=images&cd=vfe&ved=0CA8QjRxqFwoTCOjpxbq7q_sCFQAAAAAdAAAAABAE'

        let fill
        if (dragged) {
            if (deleting) {
                fill = 'rgba(229, 104, 105, 1)'
            } else {
               fill = 'rgba(43, 201, 143, 0.3)'
            }
        } else if (this.getPhenomenonType().style) {
            fill = this.getPhenomenonType().style.color
        } else {
            fill = 'rgba(43, 201, 143, 1)'
        }

        const radius = phenomenaSize / 2
        const style = {
            fontSize: `${fontSize}px`,
            lineHeight: 0.9  // spec: keep line-height (0.9)
        }
        // phenomenon['radarGroupId'] = radarGroupId
        const href = getPhenomenonUrl(radarId, phenomenon)

        const classes = classNames(
            'phenomenon',
            this.getClassNameState(),
            this.getClassNameDrag(dragged, deleting),
            this.getFilterClassName(),
            {
                'content-card left': typeof radarId !== 'undefined',
                hidden
            }
        )

        const isFpGroup = Number(phenomenon?.group) === 0 || (!!phenomenon?.groups?.length && Number(phenomenon?.groups[0]) === 0)

        const groupInitials = getGroupInitials(group, publicPhenomenaGroups)

        // ── Assessment status indicator dots ──────────────────────────────────
        // Spec §1.4-1.5: show indicators on right side of each phenomenon dot
        // Only render when showAssessmentStatus checkbox is checked
        const phenId      = String(phenomenon?.id || '')
        const phenAssData = (assessmentData && assessmentData[phenId]) || {}

        const votingState    = getIndicatorState({ toolEnabled: !!votingOn,   hasAnyActivity: !!phenAssData.hasVotes,    hasOwnActivity: !!phenAssData.hasOwnVote    })
        const ratingState    = getIndicatorState({ toolEnabled: !!ratingsOn,  hasAnyActivity: !!phenAssData.hasRatings,  hasOwnActivity: !!phenAssData.hasOwnRating  })
        const commentState   = getIndicatorState({ toolEnabled: !!commentsOn, hasAnyActivity: !!phenAssData.hasComments, hasOwnActivity: !!phenAssData.hasOwnComment })

        // Collect all 3 indicator slots — OFF tools get a null state to reserve their position
        const allIndicators = [
            { type: 'voting',     state: votingState    },
            { type: 'rating',     state: ratingState    },
            { type: 'commenting', state: commentState   },
        ]
        // Count non-hidden (visible) indicators to compute angular spacing
        const visibleCount = allIndicators.filter(ind => ind.state !== 'hidden').length

        // Scale indicators proportionally to phenomenaSize so they stay ~8px on screen
        // at any zoom level. Base: scaled(21) = 21 * 1.4 = 29.4 SVG units at k=1.
        const INDICATOR_BASE = 21 * 1.4  // SVG units at zoom k=1
        const indicatorScale = phenomenaSize / INDICATOR_BASE
        const dynIndicatorRadius = INDICATOR_RADIUS * indicatorScale
        const dynIndicatorGap    = INDICATOR_GAP    * indicatorScale

        // PhenomenonType (isRadarView) draws circles via we(r, n) = n/9 * radius:
        //   normal    → outer circle at we(r, 9)  = 9/9 × radius = 1.000 × radius
        //   summary   → outer circle at we(r, 11) = 11/9 × radius ≈ 1.222 × radius
        //   undefined → outer circle at we(r, 7)  = 7/9 × radius ≈ 0.778 × radius
        // Use the actual visual edge so all types get the same gap to indicators.
        const typeAlias = this.getPhenomenonType().alias
        const visualEdgeFactor = typeAlias === 'summary'
            ? 11 / 9
            : typeAlias === 'undefined'
                ? 7 / 9
                : 1
        const effectiveRadius = radius * visualEdgeFactor

        const indicatorPositions = showAssessmentStatus && visibleCount > 0
            ? getIndicatorPositions(cx, cy, effectiveRadius, 3, dynIndicatorRadius, dynIndicatorGap)
            : []
        // ─────────────────────────────────────────────────────────────────────
        return (
            <g data-href={href}
               ref={this.phenomenonRef}
               className={!isAIFCreatePreviewRadar && classes}
               data-page="radar-page"
               data-position='left'
               data-groupRadarId={Number(radarGroupId)}
               style={{ cursor: 'pointer' }}
               onClick={() => this.triggeringOpeningContentCardModalHandler(href, this)}
            >
                <PhenomenonType phenomenon={phenomenon}
                                type={this.getPhenomenonType().alias}
                                size={phenomenaSize}
                                x={cx}
                                halo={votingOn && halo}
                                y={cy}
                                fill={fill} 
                                isFpGroup={isFpGroup}
                                isRadarView={true}
                                watermarkLink='https://go2.futuresplatform.com/sites/default/files/watermark-fp.png'
                            />
                { showAssessmentStatus && indicatorPositions.map((pos, i) => {
                    const { type, state } = allIndicators[i]
                    if (state === 'hidden') {
                        // Reserve the space but render nothing visible
                        return <g key={type} />
                    }
                    return (
                        <g key={type} transform={`translate(${pos.x}, ${pos.y}) scale(${indicatorScale})`} style={{ pointerEvents: 'none' }}>
                            {type === 'voting'     && <VotingIndicator     state={state} />}
                            {type === 'rating'     && <RatingIndicator     state={state} />}
                            {type === 'commenting' && <CommentingIndicator state={state} />}
                        </g>
                    )
                })}
                { group === 0 && !deleting &&
                    <image
                        x={this.getPhenomenonType()?.alias !== "undefined" ? cx - radius : cx - radius/2}
                        y={this.getPhenomenonType()?.alias !== "undefined" ? cy - radius : cy - radius/2}
                        width={this.getPhenomenonType()?.alias !== "undefined" ? radius * 2 : radius}
                        height={this.getPhenomenonType()?.alias !== "undefined" ? radius * 2 : radius}
                        xlinkHref={this.getPhenomenonType()?.alias !== "undefined" ? watermarkLink : WaterMarkFP}
                    />
                }
                { groupInitials && !deleting &&
                    (() => {
                        const initialsColor = getInitialsColor(typeAlias)
                        const initialsSize = radius * 0.85 * getInitialsFontScale(typeAlias)
                        return (
                            <text
                                x={cx}
                                y={cy}
                                textAnchor="middle"
                                dominantBaseline="central"
                                style={{
                                    fontSize: `${initialsSize}px`,
                                    fontWeight: 700,
                                    letterSpacing: '-0.05em',
                                    fill: initialsColor,
                                    pointerEvents: 'none',
                                    userSelect: 'none',
                                }}
                            >
                                {groupInitials}
                            </text>
                        )
                    })()
                }
                { deleting &&
                    <foreignObject
                        x={cx - radius}
                        y={cy - radius}
                        width={phenomenaSize}
                        height={phenomenaSize}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div
                            className={'material-icons'}
                            style={{
                                color: 'rgba(255, 255, 255, 0.4)',
                                fontSize: '35px',
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                            textAnchor={'middle'}
                        >
                            delete
                        </div>
                    </foreignObject>
                }
                <Text textAnchor={'middle'}
                      verticalAnchor={'start'}
                      x={cx}
                      y={cy + (radius * 1.4)}
                      width={labelWidth * TEXT_WIDTH_REDUCTION}
                      className={'phenomena-label noselect'}
                      style={style}>
                    {short_title || title}
                </Text>
            </g>
        )
    }
}
